import { render, staticRenderFns } from "./Privacy-ticket-Page.vue?vue&type=template&id=6a06cc7c"
import script from "./Privacy-ticket-Page.vue?vue&type=script&lang=js"
export * from "./Privacy-ticket-Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports